import { MdClose } from "react-icons/md";
import Header from "../../../../Header";

function EmailSent({ onClose }) {
  return (
    <>
      <div className="miltis-help-modal__header">
        <Header
          small
          title="Nous allons vous recontacter dans les plus brefs délais."
        />
      </div>
      <div className="miltis-form miltis-form--modal">
        <div className="miltis-email-sent">
          <button
            className="miltis-email-sent__close"
            onClick={onClose}
            type="button"
          >
            <MdClose size={24} />
            <span>Fermer</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default EmailSent;
